// React
import React from 'react';
// External libraries
import { Image, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// Internal libraries
import ContainerRounded from 'components/shared/atoms/ContainerRounded/ContainerRounded';
// Styles
import './styles.scss';

/**
 * Displays a image and text under the image (or icon), the event on click
 * is handled by either 'onClick' prop or 'to' prop, base on the input of
 * 'onClick' or 'to' an Button element or a Link element is displayed
 * if both are included the button element is displayed
 * @param {Object} props.buttonStyle - The text to be display as title
 * @param {number} props.buttonHeight - The text to be display as title
 * @param {number} props.buttonWidth - The text to be display as title
 * @param {Object} props.imageStyle - The image
 * @param {number} props.imageHeight - The text to be display as title
 * @param {number} props.imageWidth - The text to be display as title
 * @param {number} props.src - Image src
 * @param {number} props.alt - Image alt text
 * @param {number} props.title - The text displayed under the image
 * @param {Object} props.titleStyle - The style to be applied to the title
 * @param {Function} props.onClick - The function handler to click(if button)
 * @param {string} props.to - The route to navigate to (if link)
 */
class ButtonImage extends React.Component {
    constructor(props) {
        super(props);
        this.buttonStyle = props.buttonStyle ? props.buttonStyle : {};
        this.buttonHeight = props.buttonHeight ? props.buttonHeight : '';
        this.buttonWidth = props.buttonWidth ? props.buttonWidth : '';
        this.imageStyle = props.imageStyle ? props.imageStyle : {};
        this.imageHeight = props.imageHeight ? props.imageHeight : '';
        this.imageWidth = props.imageWidth ? props.imageWidth : '';
        this.src = props.src ? props.src : '';
        this.alt = props.alt ? props.alt : '';
        this.title = props.title ? props.title : '';
        this.titleStyle = props.titleStyle ? props.titleStyle : {};
        this.onClick = props.onClick ? props.onClick : '';
        this.to = props.to ? props.to : '';
    }

    imageView = () => (
        <Image
            alt={this.alt}
            src={this.src}
            height={this.imageHeight}
            width={this.imageWidth}
            className={this.imageClass}
            style={this.imageStyle}
        />
    );

    titleView = () => <p style={this.titleStyle}>{ this.title }</p>;

    render() {
        return (
            this.onClick !== ''
                ? (
                    <Button
                        onClick={this.onClick}
                        style={this.buttonStyle}
                        className="container-rounded btn-img"
                        type="button"
                    >
                        <div className="container-img">
                            {this.imageView()}
                        </div>
                        <div className="container-title">
                            {this.titleView()}
                        </div>
                    </Button>
                ) : (
                    <Link
                        to={this.to}
                    >
                        <ContainerRounded className="btn-img" style={this.buttonStyle}>
                            <div className="container-img">
                                {this.imageView()}
                            </div>
                            <div className="container-title">
                                {this.titleView()}
                            </div>
                        </ContainerRounded>
                    </Link>
                )
        );
    }
}

export default ButtonImage;
